/**
 * The client version, injected at build time from package.json. It names this
 * build in Sentry and is announced to the API through X-Client-Version.
 */
export const APP_VERSION = __APP_VERSION__;

/**
 * The API version this build was generated against, injected at build time
 * from the info.version of schema.yml.
 *
 * The API version moves at its own pace and is never expected to match
 * APP_VERSION. What matters is how far the live API has drifted past the
 * baseline this build was cut for:
 *
 * - patch: the contract is unchanged or additive only, nothing to do.
 * - minor: parts of the app are stale, the user is asked to refresh.
 * - major: the app is unusable until the user refreshes, so it is blocked.
 */
export const API_VERSION_BASELINE = __API_VERSION_BASELINE__;

export const API_VERSION_HEADER = 'X-Api-Version';
export const CLIENT_VERSION_HEADER = 'X-Client-Version';
